import _ from 'lodash';
import a from 'indefinite';
import pluralize from 'pluralize';

export function format(text, prefix, plural, determiner, mode) {
  let formattedText = text;

  if (determiner) {
    formattedText = a(formattedText);
  }
  if (plural) {
    formattedText = pluralize(formattedText, 2);
  } else {
    formattedText = pluralize(formattedText, 1);
  }

  const finalText = (prefix ? `${prefix} ` : '') + formattedText;
  if (mode === 'capitalize') {
    return _.upperFirst(finalText);
  }

  return finalText;
}

export function escapeHTML(str) {
  if(!str) {
    return str;
  }

  return str.replace(/[&<>"']/g, function (match) {
      const escapeMap = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
      };
      return escapeMap[match];
  });
}

export default {
  format,
  escapeHTML
};
